/**
 * Check if the code is being run in jest.
 */
export const isTestEnv = () => process.env.NODE_ENV === "test";
